import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-map-location-arrow-icon',
  templateUrl: './map-location-arrow.component.html'
})
export class MapLocationArrowComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
